import { render, staticRenderFns } from "./AlarmMessages.vue?vue&type=template&id=12d11794"
import script from "./AlarmMessages.vue?vue&type=script&lang=js"
export * from "./AlarmMessages.vue?vue&type=script&lang=js"
import style0 from "./AlarmMessages.vue?vue&type=style&index=0&id=12d11794&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports